import React from 'react';
import {
    NotificationContainer
} from "@abb/abb-common-ux-react";
import { MICROGRID_MESSAGES } from '../../strings';
export default function NotificationExample(props) {

    const { notitype } = props;

    const [notiData, setnotiData] = [{
        notifications: [{
            id: 1,
            type: 'banner',
            discreet: 1,
            severity: "info",
            timeout: 3000,
            text: `Please wait while we open the file in wavewin`,
        }]
    }];
    const [errornotiData, seterrornotiData] = [{
        errornotifications: [{
            id: 2,
            type: 'banner',
            discreet: 2,
            severity: "warn",
            timeout: 3000,
            text: `Error while generating url.`,
        }]
    }];
    const [updatepwd, setupdatepwd] = [{
        notifications: [{
            id: 1,

            type: 'banner',
            discreet: 1,
            severity: "success",
            timeout: 3000,
            text: `Password changed successfully`,
        }]
    }];
    const [networkParamers, setnetworkParamers] = [{
        notifications: [{
            id: 1,
            type: 'banner',
            discreet: 1,
            severity: "success",
            timeout: 3000,
            text: MICROGRID_MESSAGES.NETWORK_FILES_UPLOAD_SUCCESS,
        }]
    }];
    const [objFunctions, setobjFunctions] = [{
        notifications: [{
            id: 1,
            type: 'banner',
            discreet: 1,
            severity: "success",
            timeout: 3000,
            text: MICROGRID_MESSAGES.OBJ_FUN_DATA_SUCCESS,
        }]
    }];
    const [noFilesUpload, setnoFilesUpload] = [{
        notifications: [{
            id: 1,
            type: 'banner',
            discreet: 1,
            severity: "warn",
          
            text: MICROGRID_MESSAGES.NO_FILE_UPLOADED_NOTI,
        }]
    }];
    const [uploadSuccess, setUploadSuccess] = [{
        notifications: [{
            id: 1,
            type: 'banner',
            discreet: 1,
            severity: "success",
            timeout: 3000,
            text: `SLD details uploaded successfully`,
        }]
    }];
    const [uploadInProgess, setUploadInProgess] = [{
        notifications: [{
            id: 1,
            type: 'banner',
            discreet: 1,
            severity: "info",
            timeout: 3000,
            text: `Please wait while we configure the SLD`,
        }]
    }];
    const [uploadFailure, setUploadFailure] = [{
        notifications: [{
            id: 1,
            type: 'banner',
            discreet: 1,
            severity: "warn",
            timeout: 3000,
            text: `Oops! Something went wrong during the upload. Please try again.`,
        }]
    }];
    const [sldTooLarge, setSldTooLarge] = [{
        notifications: [{
            id: 1,
            type: 'banner',
            discreet: 1,
            severity: "info",
            timeout: 3000,
            text: `SLD file is too large. Max size is 5 MB`,
        }]
    }];
    const [sldInValidFormat, setSldInValidFormat] = [{
        notifications: [{
            id: 1,
            type: 'banner',
            discreet: 1,
            severity: "info",
            timeout: 3000,
            text: `Unsupported file format for SLD. Only PNG, JPG, JPEG allowed.`,
        }]
    }];
    const [sldFileUploadFailed, setSldFileUploadFailed] = [{
        notifications: [{
            id: 1,
            type: 'banner',
            discreet: 1,
            severity: "alarm",
            timeout: 3000,
            text: `SLD File upload failed.`,
        }]
    }];
    const [busConfigFileUploadFailed, setBusConfigFileUploadFailed] = [{
        notifications: [{
            id: 1,
            type: 'banner',
            discreet: 1,
            severity: "alarm",
            timeout: 3000,
            text: `Bus configuration File upload failed.`,
        }]
    }];



      // New notification states for PostureMetrics
    const [securityGood] = React.useState({
        notifications: [{
            id: 1,
            type: 'banner',
            discreet: 1,
            severity: "success", // Green color for success
            // timeout: 3000,
            text: `Analysis result: Plant is in good shape. Update firmware and recheck devices.`,
        }]
    });

    const [securityModerate] = React.useState({
        notifications: [{
            id: 1,
            type: 'banner',
            discreet: 1,
            severity: "warn", // Orange color for warning
            // timeout: 3000,
            text: `Analysis result: Plant is moderately secure. Update the latest versions of components.`,
             fontSize: '2px', 
        }]
    });

    const [securityCritical] = React.useState({
        notifications: [{
            id: 1,
            type: 'banner',
            discreet: 1,
            severity: "alarm", // Red color for alarm
            // timeout: 3000,
            text: `Analysis result: Plant is not secure. Update the latest versions of components immediately.`,
        }]
    });

// sbomNotification

     const [sbomuploadSuccess, setsbomUploadSuccess] = [{
        notifications: [{
            id: 1,
            type: 'banner',
            discreet: 1,
            severity: "success",
            timeout: 3000,
            text: `Sbom file uploaded successfully`,
        }]
    }];
    const [sbomuploadInProgres, setsbomUploadInProgess] = [{
        notifications: [{
            id: 1,
            type: 'banner',
            discreet: 1,
            severity: "info",
            timeout: 3000,
            text: `Sbom upload-inprogress`,
        }]
    }];
    const [sbomuploadFailure, setsbomUploadFailure] = [{
        notifications: [{
            id: 1,
            type: 'banner',
            discreet: 1,
            severity: "warn",
            timeout: 3000,
            text: `Sbom upload-failure`,
        }]
    }];
    const [SbomTooLarge, setSbomTooLarge] = [{
        notifications: [{
            id: 1,
            type: 'banner',
            discreet: 1,
            severity: "info",
            timeout: 3000,
            text: `sbom-too-large`,
        }]
    }];
    const [sbominvalidFormat, setsbomInValidFormat] = [{
        notifications: [{
            id: 1,
            type: 'banner',
            discreet: 1,
            severity: "info",
            timeout: 3000,
            text: `sbom-invalid-format`,
        }]
    }];
    const [sbomuploadFailed, setsbomFileUploadFailed] = [{
        notifications: [{
            id: 1,
            type: 'banner',
            discreet: 1,
            severity: "alarm",
            timeout: 3000,
            text: `sbom-file-upload-failed`,
        }]
    }];  





    return (
        <>
            {notitype === "true" && <NotificationContainer notifications={notiData.notifications} style={{ position: 'absolute', top: '100px', right: '0px', zIndex: 9 }} />}
            {notitype === "error" &&
                <NotificationContainer notifications={errornotiData.errornotifications} style={{ position: 'absolute', top: '100px', right: '0px', zIndex: 9 }} />}
            {notitype === "updatePassword" && <NotificationContainer notifications={updatepwd.notifications} style={{ position: 'absolute', top: '50px', right: '0px', zIndex: 9 }} />}
            {/* microfrid-notifications */}
            {notitype === "networkfiles" && <NotificationContainer notifications={networkParamers.notifications} style={{ position: 'absolute', top: '50px', right: '0px', zIndex: 9 }} />}
            {notitype === "objfuntions" && <NotificationContainer notifications={objFunctions.notifications} style={{ position: 'absolute', top: '50px', right: '0px', zIndex: 9 }} />}
            {notitype === "noFilesUpload" && <NotificationContainer notifications={noFilesUpload.notifications} style={{ position: 'absolute', top: '130px', right: '0px', zIndex: 9 }} />}
            {/* wnt-notifications */}
            {notitype === "upload-inprogress" && <NotificationContainer notifications={uploadInProgess.notifications} style={{ position: 'absolute', top: '130px', right: '0px', zIndex: 9 }} />}
            {notitype === "upload-success" && <NotificationContainer notifications={uploadSuccess.notifications} style={{ position: 'absolute', top: '130px', right: '0px', zIndex: 9 }} />}
            {notitype === "upload-failure" && <NotificationContainer notifications={uploadFailure.notifications} style={{ position: 'absolute', top: '130px', right: '0px', zIndex: 9 }} />}
            {notitype === "sld-too-large" && <NotificationContainer notifications={sldTooLarge.notifications} style={{ position: 'absolute', top: '130px', right: '0px', zIndex: 9 }} />}
            {notitype === "sld-invalid-format" && <NotificationContainer notifications={sldInValidFormat.notifications} style={{ position: 'absolute', top: '130px', right: '0px', zIndex: 9 }} />}
            {notitype === "sld-file-upload-failed" && <NotificationContainer notifications={sldFileUploadFailed.notifications} style={{ position: 'absolute', top: '130px', right: '0px', zIndex: 9 }} />}
            {notitype === "bus-config-upload-failed" && <NotificationContainer notifications={busConfigFileUploadFailed.notifications} style={{ position: 'absolute', top: '130px', right: '0px', zIndex: 9 }} />}
           
                {/* New NotificationContainers for PostureMetrics */}
            {notitype === "security-good" && <NotificationContainer notifications={securityGood.notifications} style={{ position: 'fixed', top: '220px', right: '20px', zIndex: 999,height:"70px" }} />}
            {notitype === "security-moderate" && <NotificationContainer notifications={securityModerate.notifications} style={{ position: 'fixed', top: '220px', right: '20px', zIndex: 999 ,height:"70px"}} />}
            {notitype === "security-critical" && <NotificationContainer notifications={securityCritical.notifications} style={{ position: 'fixed', top: '220px', right: '20px', zIndex: 999 ,height:"70px"}} />}
        
              {/* sbomfile notification */}
            {notitype === "sbom-upload-inprogress" && <NotificationContainer notifications={sbomuploadInProgres.notifications} style={{ position: 'absolute', top: '130px', right: '0px', zIndex: 9 }} />}
            {notitype === "sbom-upload-success" && <NotificationContainer notifications={sbomuploadSuccess.notifications} style={{ position: 'absolute', top: '130px', right: '0px', zIndex: 9 }} />}
            {notitype === "sbom-upload-failure" && <NotificationContainer notifications={sbomuploadFailure.notifications} style={{ position: 'absolute', top: '130px', right: '0px', zIndex: 9 }} />}
            {notitype === "sbom-too-large" && <NotificationContainer notifications={SbomTooLarge.notifications} style={{ position: 'absolute', top: '130px', right: '0px', zIndex: 9 }} />}
            {notitype === "sbom-invalid-format" && <NotificationContainer notifications={sbominvalidFormat.notifications} style={{ position: 'absolute', top: '130px', right: '0px', zIndex: 9 }} />}
            {notitype === "sbom-file-upload-failed" && <NotificationContainer notifications={sbomuploadFailed.notifications} style={{ position: 'absolute', top: '130px', right: '0px', zIndex: 9 }} />}

        </>
    );

}
<NotificationExample />;